// The town's things, kept up to date from what changed (2 Nov). The town used to send every entity, about 80 KB, nearly
// three times a second to every viewer, and that was most of October's bandwidth bill. It now sends what changed
// (`entitiesChanged`) and what went away (`entitiesGone`), with the whole list every half minute
// (sim-server/src/network/EntityDelta.js). A changed one keeps its place, so anything that reads the list in order
// (the food indicators compare by position) sees the same order as before; a new one goes on the end.

export function mergeEntities(list = [], changed = [], gone = []) {
  if (!changed?.length && !gone?.length) return list
  const by = new Map((list || []).map((e) => [e.id, e]))
  for (const e of changed || []) if (e?.id != null) by.set(e.id, e)
  for (const id of gone || []) by.delete(id)
  return [...by.values()]
}
